import Swal from 'sweetalert2'
import moment from 'moment-timezone';

/*
** Converts UTC timestamp to local timezone and formats it
** @param {string} timestamp - UTC timestamp (e.g., "2025-02-12T07:01:19.000Z")
** @param {string} timezone - Timezone string (e.g., "Asia/Kolkata", "America/New_York")
*/
export const convertUTCToLocal = (timestamp, timezone) => {
  if (!timestamp || !timezone || !moment.tz.zone(timezone)) {
    return 'Invalid timestamp or timezone';
  }

  const localTime = moment.utc(timestamp).tz(timezone);
  return localTime.format('DD MMM, YYYY hh:mm A'); // Example: 12 Feb, 2025 - 12:31 PM
};

export function logOutRedirectCall(){
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem('user_id');
  localStorage.removeItem('name');
  localStorage.removeItem('email');
  localStorage.removeItem('profile_image');
  localStorage.removeItem('password');
  localStorage.removeItem('country_code');
  localStorage.removeItem('phone');
  window.location.reload()
}

export async function logoutConfirmation() {
  // Show confirmation dialog
  const result = await Swal.fire({
      title: "",
      text: `Are you sure you want to sign out?`,
      imageUrl: process.env.PUBLIC_URL + '/logo.png',
      imageSize: '80x80',
      showCancelButton: true,
      confirmButtonColor: "#B6A878",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sign out",
  });
  if (result.isConfirmed) {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem('user_id');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('profile_image');
    localStorage.removeItem('password');
    localStorage.removeItem('country_code');
    localStorage.removeItem('phone');
    window.location.reload()
    showMessage("Sign out successfully");
  }
}
  
export function saveUserSession(data){
  localStorage.setItem("token", data.token);
  localStorage.setItem("role", data.role);
  localStorage.setItem('user_id', data.id);
  localStorage.setItem('name', data.name);
  localStorage.setItem('email', data.email);
  localStorage.setItem('profile_image', data.profile_image);
  localStorage.setItem('password', data.password);
  localStorage.setItem('timezone', data.timezone);
  localStorage.setItem('country_code', data.country_code);
  localStorage.setItem('phone', data.phone);
}

export const showMessage = (msg) => {
  Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: msg,
      toast: true,
      showConfirmButton: false,
      timer: 5000
  })
}

export const showErrorMessage = (msg) => {
  Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: msg,
      toast: true,
      showConfirmButton: false,
      timer: 5000
  })
}